import React, {useState} from 'react';
import {Card} from 'antd';
import {EyeInvisibleOutlined, EyeTwoTone} from '@ant-design/icons';
import InputComponent from '../../../atoms/Inputs/Input';
import styles from './style.module.css';

interface FormProps {
    password: string;
    repeatPassword: string;
    passwordMatch: boolean;
    passwordValid: boolean;
    required: boolean;
    passwordErrors: string[];
    onPasswordChange: (value: string) => void;
    onRepeatPasswordChange: (value: string) => void;
    onSubmit: (event: React.FormEvent) => Promise<void>;
}

const SetPasswordForm: React.FC<FormProps> = ({
                                                  passwordMatch, repeatPassword, password, passwordValid,
                                                  required, passwordErrors, onPasswordChange, onRepeatPasswordChange
                                              }) => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [repeatPasswordVisible, setRepeatPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const toggleRepeatPasswordVisibility = () => {
        setRepeatPasswordVisible(!repeatPasswordVisible);
    };

    return (
        <Card title={<span style={{color: '#1677ff', fontWeight: 'bold', fontSize: '30px'}}>Set password</span>}>
            <form className={styles.setPasswordForm}>
                <div style={{position: 'relative', marginBottom: '20px'}}>
                    <InputComponent label={'Password'} value={password} placeholder={''} onChange={onPasswordChange}
                                    type={passwordVisible ? 'text' : 'password'} labelPosition={'up'}
                                    required={required}
                    />
                    {!passwordValid && (
                        <ul style={{ marginTop: 5, color: 'red', paddingLeft: 18 }}>
                            {passwordErrors.map(err => (<li key={err}>{err}</li>))}
                        </ul>
                    )}

                    <button type="button" onClick={togglePasswordVisibility}
                            style={{
                                position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)',
                                cursor: 'pointer', background: 'none', border: 'none', color: '#1677ff'
                            }}
                    >
                        {passwordVisible ? <EyeInvisibleOutlined/> : <EyeTwoTone/>}
                    </button>
                </div>

                <div style={{position: 'relative', marginBottom: '20px'}}>
                    <InputComponent label={'Repeat Password'} value={repeatPassword} placeholder={''}
                                    type={repeatPasswordVisible ? 'text' : 'password'} labelPosition={'up'}
                                    required={required}
                                    onChange={onRepeatPasswordChange}
                    />
                    {!passwordMatch && (<span style={{color: 'red'}}>Password does not match</span>)}
                    <button type="button" onClick={toggleRepeatPasswordVisibility}
                            style={{
                                position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)',
                                cursor: 'pointer', background: 'none', border: 'none', color: '#1677ff'
                            }}
                    >
                        {repeatPasswordVisible ? <EyeInvisibleOutlined/> : <EyeTwoTone/>}
                    </button>
                </div>
            </form>
        </Card>
    );
};

export default SetPasswordForm;